import React, { useContext, useEffect, useState } from 'react'
import { Button, Notification, toast } from 'components/ui'
import { getReadableByURL } from 'utils/getReadableByURL';
import { CompanyContext } from 'contexts/CompanyContext';
import { Loading } from 'components/shared';
import { stripHTML } from 'utils/stripHTML';
import { AIContext } from "contexts/AIContext";
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';
const NewsDetailsModal = ({ news }) => {

    const { company } = useContext(CompanyContext);
    const { whitelabel } = useWhitelabel();
    const [ newsContent, setNewsContent ] = useState();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isLoadingSummary, setIsLoadingSummary ] = useState(false);
    const [ summary, setSummary ] = useState("");
    const { getByQueryChat } = useContext(AIContext);

    const getHTML = async (theUrl) => {
        setIsLoading(true);
        getReadableByURL(theUrl).then((article) => {
            var doc = new DOMParser().parseFromString(article?.content, "text/html");
            var elements = doc.getElementsByTagName('figure')
            while (elements[0]) elements[0].parentNode.removeChild(elements[0])
            var elements = doc.getElementsByTagName('em')
            while (elements[0]) elements[0].parentNode.removeChild(elements[0])
            var elements = doc.getElementsByTagName('section')
            while (elements[0]) elements[0].parentNode.removeChild(elements[0])
            var elements = doc.getElementsByTagName('page-utils')
            while (elements[0]) elements[0].parentNode.removeChild(elements[0])
            setNewsContent(doc.body.outerHTML);
        }).finally(() => {
            setIsLoading(false);
        }); 
    }

    const summarizeNews = async () => {
        setIsLoadingSummary(true);
        try {
            const article = await getReadableByURL(news?.url);
            const title = article?.title;
            const textContent = article?.textContent?.length > 9000 ? article?.textContent?.substring(0, 9000) : article?.textContent;
            const query = `
                Given the following article: \n
                Title: ${title}\n
                Content: ${textContent}\n\n
                Write one short paragraph with the article summary.
                And explain in a SEPARATE paragraph using a line break how ${company?.name} can use this article content to post in social media or how it can benefit from it. 
            `;
            getByQueryChat(query).then((response) => {
                setSummary(response);
            }).finally(() => {
                setIsLoadingSummary(false);
            })
        } catch (err) {
            toast.push(<Notification variant="warning" title={`We couldn't read this news: ${news?.title}`} />)
            setIsLoadingSummary(false);
        }
    }

    useEffect(() => {
        const asyncFunction = async () => {
            getHTML(news?.url);
        }
        asyncFunction();
    }, [news]);

    return (
        <div className='px-2 flex flex-col gap-6'>
            {news?.urlToImage && <img onError={(e) => e.target.style.display = "none"} src={news?.urlToImage} className="w-auto max-w-none rounded-t-2xl h-[350px] object-cover -mx-8 -mt-6 " />}
            <h2 className='mega-title'>{news?.title}</h2>
            {!summary && !!stripHTML(newsContent) && <div><Button variant="solid" loading={isLoadingSummary} icon={`🤖`} onClick={summarizeNews}>&nbsp; Summarize news with AI</Button></div>}
            {summary &&
                <div className='p-6 rounded-2xl border border-gray-200 dark:border-gray-700 bg-primary-600 !text-white !text-sm whitespace-pre-wrap'>
                    <big className='font-bold'>🤖&nbsp; {whitelabel?.name}'s AI Summary</big>
                    <br/>
                    <br/>

                    {summary}
                </div>
            }
            {isLoading && <Loading type={'element'} />}
            {newsContent && <div dangerouslySetInnerHTML={{__html: newsContent}}></div>}
        </div>
    );
}

export default NewsDetailsModal